module.exports = __webpack_public_path__ + "img/lanqiuzhibo.6500cfc6.png";